export default __webpack_public_path__ + "static/media/Litto-1.c4899de7.png";